import { render, staticRenderFns } from "./PersonalLoanFormStatusModal.vue?vue&type=template&id=790ce522"
import script from "./PersonalLoanFormStatusModal.vue?vue&type=script&lang=js"
export * from "./PersonalLoanFormStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports